import Marionette from "backbone.marionette";

import SectionsTpl from "views/sections/sections.ejs";
import SectionsList from "views/sections/sectionsList.js";

import CSS from "views/sections/sections.css";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({
    template: SectionsTpl,
    render: function() {
        this.collection.fetch({
            beforeSend: T.useToken,
            data: {
                user_id: this.model.id,
                role: this.model.attributes.role,
                company: S.companyId,
                instanceId: S.instanceId
            },
            success: this.applyView.bind(this)
        });
    },
    events: {
        "click #include": "include",
        "click #exclude": "exclude",
        "change #selectEnv": "showPermissions",
        "click #send": "submit"
    },
    applyView: function() {

        // Merge local and generic translations for the template scope
        Object.assign(this.collection.lang, S.userInfo.attributes.lang);

        this.$el.html(this.template({
            lang: this.collection.lang,
            role: this.model.attributes.role,
            first_name: this.model.attributes.first_name,
            last_name: this.model.attributes.last_name
        }));

        ////USUARIO GESTOR - Y USUARIO NORMAL 
        if (this.model.attributes.role > 2) {
            $("#env_no_view").empty();
            $("#env_view").empty();

            _.each(this.collection.models[0].attributes.instances, function(instance) {
                if (!instance.user_id) {
                    $("#env_no_view").append('<option value="' + instance.id + '">' + instance.name + '</option>');
                } else {
                    $("#env_view").append('<option value="' + instance.id + '">' + instance.name + '</option>');
                    //Fill combo with visible envs
                    $("#selectEnv").append('<option value="' + instance.id + '">' + instance.name + '</option>');
                }
            });
        } else {
            $("#company_no_view").empty();
            $("#company_view").empty();
            _.each(this.collection.models, function(model) {
                if (!model.attributes.userId) {
                    $("#company_no_view").append('<option value="' + model.id + '">' + model.attributes.name + '</option>');
                } else {
                    $("#company_view").append('<option value="' + model.id + '">' + model.attributes.name + '</option>');
                }
            });
        }

        $("#load_giggg").hide();
    },
    include: function(ev) {
        ev.preventDefault();
        $("#env_no_view :selected, #company_no_view :selected").each(function() {
            $("#env_view, #company_view").append('<option value="' + $(this).attr("value") + '">' + $(this).text() + '</option>');
            $(this).remove();
        });

        this.syncSelectEnv();
    },
    exclude: function(ev) {
        ev.preventDefault();
        $("#env_view :selected, #company_view :selected").each(function() {
            $("#env_no_view, #company_no_view").append('<option value="' + $(this).attr("value") + '">' + $(this).text() + '</option>');
            $(this).remove();
        });

        this.syncSelectEnv();
    },
    //Fill combo with visible envs
    syncSelectEnv: function() {
        $("#selectEnv").empty().append('<option>' + this.collection.lang.SELECT_ENV + '</option');
        $("#env_view option").each(function() {
            $("#selectEnv").append('<option value="' + $(this).attr("value") + '">' + $(this).text() + '</option>');
        });
    },
    showPermissions: function(ev) {


        $("#permissionSet").html('');

        if (isNaN($(ev.target).val())) {

            $("#permissionSet").empty();
            return;
        }

        this.collection.fetch({
            beforeSend: T.useToken,
            data: {
                user_id: this.model.id,
                instance_id: $(ev.target).val(),
                company: S.companyId
            },
            success: function() {
                // Merge local and generic translations for the template scope
                Object.assign(this.collection.lang, S.userInfo.attributes.lang);

                this.permissionSet.show(new SectionsList({
                    collection: this.collection,
                    role_us: this.model.attributes.role
                }));
            }.bind(this)
        });
    },
    submit: function(ev) {

        $("#load_giggg").show();
        $("#send").hide();

        var formData = {};
        /////USUARIO NORMAL Y USUARIO GESTOR ..
        if (this.model.attributes.role === "3" || this.model.attributes.role === "2") {
            formData.instances = [];
            $.each($("#env_view option"), function() {
                formData.instances.push(parseInt($(this).attr("value")));
            })


            formData.permissionsSections = [];
            $.each($(".subepigraph"), function() {

                var descriptivos = 0;
                var juridicos = 0;
                var acuerdos = 0;
                var registrales = 0;
                var urbanisticos = 0;
                var seguros = 0;
                var mejoras = 0;
                var ampliada = 0;
                var documentos = 0;
                var titulos = 0;
                var catastrales = 0;
                var gps = 0;
                var economicos = 0;


                descriptivos = $(this).find(".descriptivos").prop("checked") === true ? 1 : descriptivos;
                juridicos = $(this).find(".juridicos").prop("checked") === true ? 1 : juridicos;
                acuerdos = $(this).find(".acuerdos").prop("checked") === true ? 1 : acuerdos;
                registrales = $(this).find(".registrales").prop("checked") === true ? 1 : registrales;
                urbanisticos = $(this).find(".urbanisticos").prop("checked") === true ? 1 : urbanisticos;
                seguros = $(this).find(".seguros").prop("checked") === true ? 1 : seguros;
                ampliada = $(this).find(".ampliada").prop("checked") === true ? 1 : ampliada;
                documentos = $(this).find(".documentos").prop("checked") === true ? 1 : documentos;
                titulos = $(this).find(".titulos").prop("checked") === true ? 1 : titulos;
                mejoras = $(this).find(".mejoras").prop("checked") === true ? 1 : mejoras;
                catastrales = $(this).find(".catastrales").prop("checked") === true ? 1 : catastrales;
                gps = $(this).find(".gps").prop("checked") === true ? 1 : gps;
                economicos = $(this).find(".economicos").prop("checked") === true ? 1 : economicos;


                formData.permissionsSections.push({
                    id: $(this).attr("id"),
                    item: $(this).attr("data-item"),
                    is_sei_descriptivos: descriptivos,
                    is_sei_juridicos: juridicos,
                    is_sei_acuerdos: acuerdos,
                    is_sei_registrales: registrales,
                    is_sei_urbanisticos: urbanisticos,
                    is_sei_seguros: seguros,
                    is_sei_mejoras: mejoras,
                    is_sei_ampliada: ampliada,
                    is_sei_documentos: documentos,
                    is_sei_titulos: titulos,
                    is_sei_catastrales: catastrales,
                    is_sei_gps: gps,
                    is_sei_economicos: economicos,
                });


            });




            formData.user_id = this.model.id;
            formData.instance_id = $("#selectEnv").val();
            formData.role = "3";

        } else {
            formData.companies = [];
            $.each($("#company_view option"), function() {
                formData.companies.push(parseInt($(this).attr("value")));
            });

            formData.user_id = this.model.id;
            formData.role = "1";
        }

        //Force POST operation
        delete this.collection.models[0].id;

        this.collection.models[0].save(formData, {
            beforeSend: T.useToken,
            success: function() {


                $("#load_giggg").hide();
                $("#send").show();

                S.mApp.trigger("notify:success", {
                    message: S.userInfo.attributes.lang.INSERT_OK
                });
            },
            error: function() {


                $("#load_giggg").hide();
                $("#send").show();



                S.mApp.trigger("notify:error", {
                    message: S.userInfo.attributes.lang.INSERT_ERROR
                });
            }
        });



        return false;
    },
    regions: {
        "permissionSet": "#permissionSet"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/sections/sectionsView.js
// module id = 208
// module chunks = 0